import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminLayout } from './components/layout/AdminLayout';
import { ProtectedRoute } from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import ClientDetail from './pages/ClientDetail';
import Plans from './pages/Plans';
import Billing from './pages/Billing';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Themes from './pages/Themes';
import AiUsage from './pages/AiUsage';

function App() {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:slug" element={<ClientDetail />} />
        <Route path="plans" element={<Plans />} />
        <Route path="billing" element={<Billing />} />
        <Route path="ai-usage" element={<AiUsage />} />
        <Route path="settings" element={<Settings />} />
        
        {/* Superadmin only routes */}
        <Route
          path="users"
          element={
            <ProtectedRoute requireSuperAdmin>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="themes"
          element={
            <ProtectedRoute requireSuperAdmin>
              <Themes />
            </ProtectedRoute>
          }
        />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
